import { isValid, isBefore, isAfter, isWeekend } from 'date-fns';
import { DatePickerError } from './DatePickerError';
export function validateDate(_a) {
    var date = _a.date, value = _a.value, options = _a.options;
    if (!value || !date) {
        return null;
    }
    if (!isValid(date)) {
        return DatePickerError.INVALID_DATE;
    }
    if (isBefore(date, options.minDate)) {
        return options.disablePast
            ? DatePickerError.PAST_NOT_ALLOWED
            : DatePickerError.BEFORE_MIN_DATE;
    }
    if (isAfter(date, options.maxDate)) {
        return options.disableFuture
            ? DatePickerError.FUTURE_NOT_ALLOWED
            : DatePickerError.AFTER_MAX_DATE;
    }
    if (options.disableWeekend && isWeekend(date)) {
        return DatePickerError.WEEKEND_NOT_ALLOWED;
    }
    if (options.shouldDisableDate && options.shouldDisableDate(date)) {
        return DatePickerError.DISABLED_DATE;
    }
    return null;
}
//# sourceMappingURL=validateDate.js.map